  <template>
  <div>
    <!-- <h1>Crear Permiso Provisional</h1> -->
    <!-- <router-link to="/permisos-provisionales/gestionar" style=" text-decoration: underline; margin-bottom: 16px; display: inline-block;">
      Volver a Permisos
    </router-link> -->
    
    <v-form ref="form" v-model="valid" lazy-validation
    v-if="!showMessageSuccess">
      <v-row dense>
        
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            v-model="formulario.patente"
            label="Patente"
            outlined
            clearable
            maxlength="6"
            :placeholder="'Ej: PR0003'"
            :rules="[rules.required]"
            @input="formulario.patente = formulario.patente.toUpperCase()"
          />
        </v-col>

     
        <v-col cols="12" sm="4" md="4">
          
           <v-select
            v-model="formulario.anio"
            :items="anios"
            label="Año Permiso"
            outlined
            clearable
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-select
            v-model="formulario.semestre"
            :items="[1, 2]"
            label="Semestre Permiso"
            outlined
            clearable
            :rules="[rules.required]"
          />
        </v-col>
         </v-row>
      <v-row dense>
        <v-col cols="12" sm="3" md="3">
          <v-select
            v-model="formulario.marca"
            :items="getMarcas()"
            label="Marca"
            outlined
            clearable
            :rules="[rules.required]"
            :disabled="!!formulario.modelo"
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-select
            v-model="formulario.modelo"
            :items="getModelos()"
            label="Modelo"
            outlined
            clearable
            :rules="[rules.required]"
            :disabled="!!formulario.tipo_vehiculo"
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-select
            v-model="formulario.tipo_vehiculo"
            :items="getTipos()"
            label="Tipo"
            outlined
            clearable
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model.number="formulario.anio_fabricacion"
            label="Año de Fabricación"
            outlined
            clearable
            type="number"
            :rules="[rules.required, rules.numeric, value => value > 2000 || 'Debe ser mayor a 2000']"
          
          />
        </v-col>  </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            v-model="formulario.automotora_razon_social"
            label="Razón Social Automotora"
            outlined
            clearable
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            v-model="formulario.automotora_nombre"
            label="Nombre Automotora"
            outlined
            clearable
          />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            v-model="formulario.automotora_rut"
            label="RUT Automotora"
            outlined
            clearable
            :rules="[rules.rut]"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="formulario.automotora_direccion"
            label="Dirección Automotora"
            outlined
            clearable
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="formulario.automotora_comuna"
            label="Comuna Automotora"
            outlined
            clearable
            disabled
          />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="formulario.automotora_representante_rut"
            label="RUT Representante Automotora"
            outlined
            clearable
            :rules="[rules.rut]"
          />
        </v-col>

        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="formulario.automotora_representante_nombre"
            label="Nombre Representante Automotora"
            outlined
            clearable
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <v-btn color="primary" outlined :disabled="!valid" @click="crearPatente">
            Crear Patente
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-alert type="success" v-if="showMessageSuccess">
      <p >
        Patente creada exitosamente.
      </p>
    </v-alert>
    <v-btn color="primary" v-if="showMessageSuccess" @click="showMessageSuccess = false; resetFormulario()">
            Agregar otra patente
    </v-btn>

    
    
    <v-alert
      v-if="errores.length"
      type="error"
      dismissible
      border="left"
      color="red"
      class="mb-4"
    >
      <ul>
        <li v-for="(error, index) in errores" :key="index">
          {{ error }}
        </li>
      </ul>
    </v-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMessageSuccess: false,
      valid: false,
      formulario: {
        estado: 'Vigente',
        patente: '',
        anio: new Date().getFullYear(),
        semestre: null,
        anio_fabricacion: null,
        automotora_razon_social: '',
        automotora_nombre: '',
        automotora_rut: '',
        automotora_direccion: '',
        automotora_comuna: '',
        automotora_representante_rut: '',
        automotora_representante_nombre: '',
        marca: null,
        tipo: null,
        modelo: '',
      },
      anios: [new Date().getFullYear(), new Date().getFullYear() + 1],
      errores:[],
      // marcas: [],
      // modelos: [],
      // tipos: [],
      todosModelos:[],
      comuna: null,
      rules: {
        required: (value) => !!value || 'Este campo es obligatorio.',
        numeric: (value) => !isNaN(value) || 'Debe ser un número.',
        rut: (value) => /^[0-9]+-[0-9kK]$/.test(value) || 'RUT inválido.',
      },
    };
  },
  mounted() {
    this.getAuxiliares();
  },
  methods: {
    getAuxiliares() {
      // this.$axios
      //   .get('bum/permisos-provisionales/modelos-vehiculos/marcas')
      //   .then((response) => {
      //     this.marcas = response.data.marcas;
      //   });
      // this.$axios
      //   .get('bum/permisos-provisionales/modelos-vehiculos/tipos')
      //   .then((response) => {
      //     this.tipos = response.data.tipos;
      //   });
      // this.$axios
      //   .get('bum/permisos-provisionales/modelos-vehiculos/modelos')
      //   .then((response) => {
      //     this.modelos = response.data.modelos;
      //   });
        this.$axios
        .get('bum/permisos-provisionales/comuna-usuario')
        .then((response) => {
          
          this.formulario.automotora_comuna=response.data.nombre;
        });
        this.buscarTodos();
    },
     buscarTodos() {
      // this.modelos =[]
      this.$axios
        .get(`bum/permisos-provisionales/modelos-vehiculos/listTodos`)
        .then((response) => {
          this.todosModelos = response.data
        })
    },
    getMarcas() {
      return this.todosModelos
      .map((modelo) => modelo.marca)
      .filter((marca, index, self) => self.indexOf(marca) === index)
      .sort((a, b) => a.localeCompare(b));
    
    },
    
    getModelos() {
      let modelos = this.todosModelos;
      if (this.formulario.marca) {
        modelos = modelos.filter((modelo) => modelo.marca === this.formulario.marca);
      }
      return modelos
        .map((modelo) => modelo.modelo)
        .filter((modelo, index, self) => self.indexOf(modelo) === index)
        .sort((a, b) => a.localeCompare(b));
    
    },

    getTipos()
    {
      let tipos = this.todosModelos;
      if (this.formulario.marca) {
        tipos = tipos.filter((modelo) => modelo.marca === this.formulario.marca);
      }
      if (this.formulario.modelo) {
        tipos = tipos.filter((modelo) => modelo.modelo === this.formulario.modelo);
      }
      return tipos
        .map((modelo) => modelo.tipo)
        .filter((tipo, index, self) => self.indexOf(tipo) === index)
        .sort((a, b) => a.localeCompare(b));
    },
    crearPatente() {
      this.errores =[];
      if (this.$refs.form.validate()) {

        this.$axios
        .post('bum/permisos-provisionales/create', this.formulario)
        .then(() => {
            this.resetFormulario();
            this.showMessageSuccess = true;
            
          }).catch((error) => {
                if (error.response && error.response.status === 422) {
                  this.errores = error.response.data.errores;
                } else {
                  this.errores = ['Ocurrió un error inesperado.'];
                }
                // this.$toast.error('Error al crear la patente.');
                });  }
    },
    resetFormulario() {

      this.formulario =  {
        estado: 'Vigente',
        patente: '',
        anio: null,
        semestre: null,
        anio_fabricacion: null,
        automotora_razon_social: '',
        automotora_nombre: '',
        automotora_rut: '',
        automotora_direccion: '',
        automotora_comuna: '',
        automotora_representante_rut: '',
        automotora_representante_nombre: '',
        marca: null,
        tipo: null,
        modelo: '',
      }
    },
  },
};
</script>
